import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronRight, Menu as MenuIcon, X } from "lucide-react";

const LINKS = [
  ["Story", "about"],
  ["Menu", "menu"],
  ["Gallery", "gallery"],
  ["Visit", "visit"],
];

const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 320);
  };
  return (
    <header
      className="fixed left-0 right-0 top-0 z-50 border-b border-[#1A1713]/10 bg-[#F5F2EA]/85 backdrop-blur-md"
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-12">
        <button
          data-testid="nav-brand"
          onClick={() => {
            setOpen(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="font-serif text-2xl tracking-tight text-[#1A1713]"
        >
          Kal's <span className="italic text-[#5C564D]">Cafe</span>
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => go(id)}
              className="text-xs font-medium uppercase tracking-[0.2em] text-[#5C564D] transition-colors hover:text-[#1A1713]"
            >
              {label}
            </button>
          ))}
          <span className="flex items-center gap-1" aria-hidden="true">
            <span className="block h-1.5 w-1.5 rounded-full bg-[#078930]" />
            <span className="block h-1.5 w-1.5 rounded-full bg-[#FCDD09]" />
            <span className="block h-1.5 w-1.5 rounded-full bg-[#DA121A]" />
            <span className="block h-1.5 w-1.5 rounded-full bg-[#0F47AF]" />
          </span>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label="Open menu"
          className="flex h-9 w-9 items-center justify-center border border-[#1A1713]/15 text-[#1A1713] md:hidden"
        >
          {open ? <X className="h-4 w-4" /> : <MenuIcon className="h-4 w-4" />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden border-t border-[#1A1713]/10 md:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col px-6 py-3">
              {LINKS.map(([label, id]) => (
                <button
                  key={id}
                  data-testid={`nav-mobile-link-${id}`}
                  onClick={() => go(id)}
                  className="flex items-center justify-between border-b border-[#1A1713]/5 py-3.5 text-left text-sm font-medium uppercase tracking-[0.2em] text-[#1A1713] last:border-b-0"
                >
                  {label}
                  <ChevronRight className="h-4 w-4 text-[#5C564D]" />
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Nav;
